import Carousel from '../../../components/Carousel'
import React, {useEffect, useMemo, useState} from 'react'
import {ModeleVehiculeEntre} from '../../../components/Models'
import moment from 'moment'
import {KTSVG} from '../../../_metronic/helpers'

const DemontageToShowPage = ({
  vehicule,
  setVehiculeToShow,
  vehicules = [],
}: {
  vehicule: ModeleVehiculeEntre
  setVehiculeToShow: any
  vehicules?: any
}) => {
  const [imgArr, setImgArr] = useState<string[]>([])

  // On trouve l'index à la volée à chaque rendu
  // Si le parent clique sur un véhicule, l'index se met à jour instantanément
  const currentIndex = useMemo(() => {
    if (!vehicules.length || !vehicule) return 0
    const index = vehicules.findIndex((item) => item[0]?.id === vehicule?.id)
    return index !== -1 ? index : 0
  }, [vehicules, vehicule])

  const nextSlide = () => {
    if (!vehicules.length) return
    const nextIndex = (currentIndex + 1) % vehicules.length
    setVehiculeToShow(vehicules[nextIndex][0])
  }

  const prevSlide = () => {
    if (!vehicules.length) return
    const prevIndex = (currentIndex - 1 + vehicules.length) % vehicules.length
    setVehiculeToShow(vehicules[prevIndex][0])
  }

  useEffect(() => {
    let isMounted = true

    const loadImages = async () => {
      if (!vehicule) {
        setImgArr([])
        return
      }

      const immat = vehicule.immatriculation
      const nombrePhotos =
        vehicule.nombrePhotos && vehicule.nombrePhotos > 0 ? vehicule.nombrePhotos : 15

      if (!immat) {
        setImgArr([])
        return
      }

      const firstImmatChar = immat.substring(0, 1)
      const arrTemp = Array.from(
        {length: nombrePhotos},
        (_, i) => `Photos${firstImmatChar}/${immat}_${i + 1}.jpg`
      )

      // Vérification de l'existence des images sur le cloud
      const existingImages = await Promise.all(
        arrTemp.map(
          (relativeUrl) =>
            new Promise<string | null>((resolve) => {
              const img = new Image()
              img.onload = () => resolve(relativeUrl)
              img.onerror = () => resolve(null)
              img.src = `https://d1zsawkzupb9kl.cloudfront.net/${relativeUrl}`
            })
        )
      )

      if (isMounted) {
        setImgArr(existingImages.filter((url): url is string => !!url))
      }
    }

    loadImages()

    return () => {
      isMounted = false
    }
  }, [vehicule])

  return (
    <>
      <div className='card p-8 h-100'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='d-flex justify-content-end'>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary mt-n6 me-n6 mb-1'
                onClick={() => {
                  setVehiculeToShow(undefined)
                }}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='position-relative'>
              <i
                className='position-absolute bi bi-zoom-in fs-2'
                data-bs-toggle='modal'
                data-bs-target='#vehiculeDetailImageModal'
                style={{
                  cursor: 'pointer',
                  zIndex: 1,
                  top: '15px',
                  right: '15px',
                }}
              ></i>
              <Carousel
                imagesArray={imgArr}
                loading={false}
                nomPiece={''}
                taille={'600x340'}
                indicator={1}
                isVehic={true}
              />
              <div
                className='modal fade'
                id='vehiculeDetailImageModal'
                aria-labelledby='vehiculeDetailImageModalLabel'
                aria-hidden='true'
              >
                <div className='modal-dialog modal-dialog-centered modal-lg'>
                  <div className='modal-content'>
                    <div className='modal-header'>
                      <h5 className='modal-title' id='vehiculeDetailImageModalLabel'>
                        Image du véhicule
                      </h5>
                      <div
                        className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                        data-bs-dismiss='modal'
                        aria-label='Close'
                      >
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr061.svg'
                          className='svg-icon svg-icon-2x'
                        />
                      </div>
                    </div>
                    <div className='modal-body text-center'>
                      <Carousel
                        imagesArray={imgArr}
                        loading={false}
                        nomPiece={''}
                        taille={'600x400'}
                        indicator={2}
                        isVehic={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-12 overflow-y-auto' style={{maxHeight: '405px'}}>
            <h3 className='my-4'>Information sur le véhicule</h3>
            <div key={vehicule[0]?.id} className='mt-5' style={{lineHeight: '1'}}>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Modèle</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.vehicule?.modele?.nom}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Immatriculation</div>
                <div className='mb-5 fs-4 bold'>{vehicule.immatriculation}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Numéro d’identification</div>
                <div className='mb-5 fs-4 bold'>{vehicule.numero}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Mise en circulation</div>
                <div className='mb-5 fs-4 bold'>
                  {vehicule.datePremiereImmat == ''
                    ? ''
                    : moment(vehicule.datePremiereImmat).format('DD/MM/YYYY')}
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>N° série</div>
                <div className='mb-5 fs-4 bold'>{}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Genre</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.vehicule?.modele?.type?.code}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Puissance</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.vehicule?.modele?.puissance}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Boîte de vitesse</div>
                <div className='mb-5 fs-4 bold'>{}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Type variante version</div>
                <div className='mb-5 fs-4 bold'>{}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Date CG</div>
                <div className='mb-5 fs-4 bold'>{}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Contrôle SIV</div>
                <div className='mb-5 fs-4 bold'>{}</div>
              </div>

              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>CNIT</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.cnit}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>VIN</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.vin}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Date d’entrée en stock</div>
                <div className='mb-5 fs-4 bold'>
                  {vehicule?.date_entree_stock
                    ? moment(vehicule.date_entree_stock).format('DD/MM/YYYY')
                    : ''}
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Site</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.site?.code}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Zone</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.zone}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Allée</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.allee}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Kilométrage</div>
                <div className='mb-5 fs-4 bold'>
                  {vehicule?.km?.toLocaleString('fr-FR') + ' Km' ?? 'NC'}
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Code moteur</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.codeMoteur}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Carburant</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.energie}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Transmission</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.boiteAuto ? 1 : 0}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Nombres de portes</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.nombrePortes}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Couleur</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.couleur}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Etat</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.etat}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Statut</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.statut}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Destination</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.destination}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Centre code</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.centre?.code}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Centre nom</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.centre?.nom}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Destination moteur</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.destinationMoteur}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Destination boite</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.destinationBoite}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Cylindré</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.vehicule?.modele?.cylindre}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Type moteur</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.typeMoteur}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Date phase début</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.datePhaseDebut}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Date phase fin</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.datePhaseFin}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Genre code</div>
                <div className='mb-5 fs-4 bold'></div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Genre libellé</div>
                <div className='mb-5 fs-4 bold'></div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Cnit</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.vehicule?.cnit}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Boite auto manuel</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.boiteAutoManu}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Année</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.annee}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Energie</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.energie}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Emplacement</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.emplacement}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Date de mise à disposition</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.dateDisposition}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Prix de vente</div>
                <div className='mb-5 fs-4 bold'>{vehicule?.prixVente}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Chevron gauche */}
        <button
          onClick={prevSlide}
          disabled={currentIndex === 0}
          className='btn btn-info rounded-circle d-flex align-items-center justify-content-center position-absolute'
          style={{
            top: '50%',
            left: '-20px',
            transform: 'translateY(-50%)',
            width: '40px',
            height: '40px',
          }}
        >
          <i className='bi bi-chevron-left'></i>
        </button>

        {/* Chevron droit */}
        <button
          onClick={nextSlide}
          disabled={currentIndex === vehicules.length - 1}
          className='btn btn-info rounded-circle d-flex align-items-center justify-content-center position-absolute'
          style={{
            top: '50%',
            right: '-20px',
            transform: 'translateY(-50%)',
            width: '40px',
            height: '40px',
          }}
        >
          <i className='bi bi-chevron-right'></i>
        </button>
      </div>
    </>
  )
}
export {DemontageToShowPage}
